const FooterEndSerie = (props: { onExit: () => void }) => {
  return (
    <div className="rd-end">
      <span className="rd-end__emoji" aria-hidden="true">
        🏆
      </span>
      <h2 className="rd-end__title">Tu as terminé la série !</h2>
      <p className="rd-end__text">Bravo, quelle lecture ! D'autres histoires t'attendent dans ta bibliothèque.</p>
      <button type="button" className="nbk-btn nbk-btn--secondary" onClick={props.onExit}>
        Retour à la série
      </button>
    </div>
  );
};

export default FooterEndSerie;
